/**
 * Process action confirmations from assistant responses
 * Returns confirmation objects to display in the UI
 */
export function processActionConfirmations(actions) {
  const confirmations = [];

  actions.forEach((action, index) => {
    let confirmation = null;
    const actionId = Date.now() + index;

    // Finance Actions
    if (action.type === "finance.add_expense" && action.data) {
      confirmation = {
        type: "success",
        title: "💸 Despesa registrada",
        details: [
          { label: "Categoria", value: action.data.category || "Outros" },
          { label: "Valor", value: `R$ ${action.data.amount?.toFixed(2)}` },
          action.data.description && { label: "Descrição", value: action.data.description },
        ].filter(Boolean),
      };
    } else if (action.type === "finance.add_income" && action.data) {
      confirmation = {
        type: "success",
        title: "💰 Receita registrada",
        details: [
          { label: "Valor", value: `R$ ${action.data.amount?.toFixed(2)}` },
          action.data.description && { label: "Descrição", value: action.data.description },
        ].filter(Boolean),
      };
    }
    
    // Task Actions
    else if (action.type === "task.create" && action.data) {
      confirmation = {
        type: "success",
        title: "✅ Tarefa criada",
        details: [
          { label: "Título", value: action.data.title },
          action.data.priority && { label: "Prioridade", value: action.data.priority.toUpperCase() },
        ].filter(Boolean),
      };
    } else if (action.type === "task.complete") {
      confirmation = {
        type: "success",
        title: "🎉 Tarefa concluída!",
        details: action.data?.title ? [{ label: "Tarefa", value: action.data.title }] : [],
      };
    } else if (action.type === "task.delete") {
      confirmation = {
        type: "info",
        title: "🗑️ Tarefa removida",
        details: [],
      };
    }
    
    // Reminder Actions
    else if (action.type === "reminder.create" && action.data) {
      confirmation = {
        type: "success",
        title: "🔔 Lembrete criado",
        details: [
          { label: "Mensagem", value: action.data.message },
          action.data.datetime && { label: "Quando", value: new Date(action.data.datetime).toLocaleString('pt-BR') },
        ].filter(Boolean),
      };
    } else if (action.type === "reminder.complete") {
      confirmation = {
        type: "success",
        title: "✓ Lembrete concluído",
        details: [],
      };
    }
    
    // Habit Actions
    else if (action.type === "habit.create" && action.data) {
      confirmation = {
        type: "success",
        title: "🎯 Hábito criado",
        details: [
          { label: "Nome", value: action.data.name },
          action.data.frequency && { label: "Frequência", value: action.data.frequency },
        ].filter(Boolean),
      };
    } else if (action.type === "habit.complete") {
      confirmation = {
        type: "success",
        title: "🔥 Hábito registrado!",
        details: action.data?.streak ? [{ label: "Sequência", value: `${action.data.streak} dias` }] : [],
      };
    }
    
    // Project Actions
    else if (action.type === "project.create" && action.data) {
      confirmation = {
        type: "success",
        title: "📁 Projeto criado",
        details: [
          { label: "Nome", value: action.data.title },
        ],
      };
    } else if (action.type === "project.task_add" && action.data) {
      confirmation = {
        type: "info",
        title: "➕ Tarefa adicionada ao projeto",
        details: [
          { label: "Tarefa", value: action.data.task_title || action.data.title },
        ],
      };
    }
    
    // Note Actions
    else if (action.type === "note.create" && action.data) {
      confirmation = {
        type: "success",
        title: "📝 Nota criada",
        details: [
          { label: "Título", value: action.data.title },
        ],
      };
    }

    if (confirmation) {
      confirmations.push({ ...confirmation, id: actionId });
    }
  });

  return confirmations;
}

/**
 * Auto-dismiss timeout for confirmations (in ms)
 */
export const CONFIRMATION_DISMISS_TIMEOUT = 5000;
